import useApi from '../api';

const useSimulatorsService = () => {
    const { api } = useApi();

    return {
        getSimulators: (origin = 'rehsult_leite', status = null) =>
            api.get(`simulators?origin=${origin}&status=${status}`).then((resp) => resp.data),
        getSimulator: (id) => api.get(`simulators/${id}`).then((resp) => resp.data),
        getSimulatorInputs: (id) => api.get(`/simulators/${id}/inputs`).then((resp) => resp.data),
        updateStatus: (id, status) => api.put(`simulators/${id}/status`, { status }).then((resp) => resp.data),
        createSimulator: async (formData, origin = 'rehsult_leite') => {
            formData.append('origin', origin);
            const { data: response } = await api.post('simulators', formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            return response;
        },
        updateSimulator: async (id, formData, type = 'inputs') => {
            formData.append('_method', 'PUT');
            const { data: response } = await api.post(`simulators/${id}?type=${type}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            return response;
        },
        getCalculateSimulator: async (id, data) => api.post(`simulators/${id}/calculate`, data).then((resp) => resp.data),
        generateSimulatorPDF: async (simulatorName, boxes) => {
            const { data } = await api.post('/simulators/pdf', { simulator: simulatorName, boxes }, { responseType: 'blob' });

            return data;
        },
        getSimulatorHistory: (data) => api.get(`/simulator-history`, { params: data }).then((resp) => resp.data.data),
        getSimulatorHistoryById: (id) => api.get(`/simulator-history-per-id/${id}`).then((resp) => resp.data),
        deleteSimulatorHistoryById: (id) => api.delete(`/simulator-history/${id}`).then((resp) => resp.data),
        enableOwnerInSimulatorHistory: (id) => api.put(`simulator-history/${id}/enable-owner`).then((resp) => resp.data),
        createSimulatorHistory: (data) => api.post(`/simulator-history`, data).then((resp) => resp.data)
    };
};

export default useSimulatorsService;
